import * as React from "react";
import { Button, Modal, Header, Grid } from "semantic-ui-react";

import { CaseMessagingReply } from "@teamprevent/common/messaging/components/CaseMessagingReply";

export interface MessagingReplyModalProps {
    caseId: string;
    subject: string;
    openModal: boolean;
    onCloseModal: () => void;
    showReply: boolean;
    customerId: string;
    action?: () => void;
    employeeName: string;
}

const MessagingReplyModal: React.FC<MessagingReplyModalProps> = ({
    caseId,
    subject,
    openModal,
    onCloseModal,
    showReply,
    customerId,
    employeeName,
}) => {
    return (
        <>
            <Modal open={openModal}>
                <Modal.Header>
                    <Grid columns="equal" verticalAlign="middle">
                        <Grid.Column>
                            <Header as="h2">
                                {`Case conversation: ${subject}`}
                            </Header>
                        </Grid.Column>
                        <Grid.Column textAlign="right">
                            <Header as="h6">{`Employee: ${employeeName}`}</Header>
                        </Grid.Column>
                    </Grid>
                </Modal.Header>
                <Modal.Content scrolling>
                    <CaseMessagingReply
                        hideTitle
                        subject={subject}
                        caseId={caseId}
                        onSubmit={onCloseModal}
                        showReply={showReply}
                        customerId={customerId}
                        employeeName={employeeName}
                    />
                </Modal.Content>
                <Modal.Actions>
                    <Button content="Exit" onClick={onCloseModal} />
                </Modal.Actions>
            </Modal>
        </>);
};

export { MessagingReplyModal };
